import { baseGetNoId } from 'services/base-services/baseService';
import { API2_HOST } from 'helpers/urlHelper';
const baseURL = `${API2_HOST}/eva-odr-automatic-report`;
const updateOdrAutomaticHtml = async () => {
  return await baseGetNoId(`${baseURL}/get-report-html`);
};

export { updateOdrAutomaticHtml };
